import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';

export const setLastCommentId = createAction<number | null>(
  `${storeName}/setLastCommentId`,
);
